import * as AT from './actionTypes'

export type TicketActionType =
  | { type: typeof AT.CREATE }
  | { type: typeof AT.RESET }
  | { type: typeof AT.UPDATE_DECIMAL_PRECISIONS }

const create = (): TicketActionType => ({
  type: AT.CREATE
})

const reset = (): TicketActionType => ({
  type: AT.RESET
})

const updateDecimalPrecisions = (): TicketActionType => ({
  type: AT.UPDATE_DECIMAL_PRECISIONS
})

export default {
  create,
  reset,
  updateDecimalPrecisions
}
